import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { deleteMachine, getAllMachines, getMachine } from '@/apis/machines'
import useNotification from '@/hooks/useNotification'
import { DeleteIdCardRequest } from '@/types/apis/idCards'
import { GetAllMachinesResponse } from '@/types/apis/machines/GetAllMachinesResponse'
import { GetMachineResponse } from '@/types/apis/machines/GetMachineResponse'

export const useMachines = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [getMachinesLoading, setGetMachinesLoading] = useState(false)
  const [getMachinesResponse, setMachinesResponse] = useState<GetAllMachinesResponse>()
  const [deleteMachineLoading, setDeleteMachineLoading] = useState(false)
  const [getMachineDetailResponse, setMachineDetailResponse] = useState<GetMachineResponse>()
  const [getMachineDetailLoading, setGetMachineDetailLoading] = useState(false)

  const get = useCallback(async () => {
    try {
      setGetMachinesLoading(true)
      const res = await getAllMachines()

      setMachinesResponse(res)
    } finally {
      setGetMachinesLoading(false)
    }
  }, [])

  const getById = useCallback(async (id: number) => {
    try {
      setGetMachineDetailLoading(true)
      const res = await getMachine({ id })

      setMachineDetailResponse(res)
    } finally {
      setGetMachineDetailLoading(false)
    }
  }, [])

  const del = useCallback(
    async ({ id }: DeleteIdCardRequest) => {
      try {
        setDeleteMachineLoading(true)
        await deleteMachine({ id })

        if (getMachinesResponse) {
          const newMachines = getMachinesResponse.filter((item) => item.id !== id)
          setMachinesResponse({ ...getMachinesResponse, ...newMachines })
        }
        openNotification({ type: 'success', description: t('components.pages.admins.common.delete.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.delete.fail') })
      } finally {
        setDeleteMachineLoading(false)
      }
    },
    [getMachinesResponse, openNotification, t]
  )

  return {
    getMachines: get,
    getMachinesResponse,
    getMachinesLoading,
    deleteMachine: del,
    deleteMachineLoading,
    getMachineDetail: getById,
    getMachineDetailResponse,
    getMachineDetailLoading,
  }
}
